<template>
    <div v-bind:class="[IsHighlight ? 'tree-selectItem' : '', disableSelection ? 'cursor-default' : '',IsSelectAbleArea('row') ? 'tree-treeText' : 'tree-treeText-disabled']"
         class="d-flex align-items-center"
         v-bind:style="{'padding-left': HierarchyPadding + 'px' }"
         style="margin-bottom: 4px;"
         v-on:click="onSelectItem(divItem, $event)">
        <template v-if="HasChildren">
            <div class="d-flex align-items-center"
                 style="width: 24px; height: 24px; cursor: pointer;">
                <div v-bind:class="isExpanded ? 'icon-font-open' : 'icon-font-close'"
                     v-on:click="onClickExpand()"
                     style="margin-right: auto; margin-left: auto">
                    <i v-bind:class="isExpanded ? 'icon-arrow1down' : 'icon-arrow1right'"></i>
                </div>
            </div>
        </template>
        <div v-bind:class="IsSelectAbleArea('text') ? 'tree-treeText' : 'tree-treeText-disabled'" class="d-flex">
            <template v-if="1 == selectMode || 2 == selectMode">
                <div class="d-flex justify-content-center align-items-center" style="margin-left: 4px; width: 24px; height: 24px">
                    <label class="scv-check-label-box">
                        <input type="checkbox"
                               :indeterminate="isIndeterminate"
                               v-bind:checked="hideUnviewableDivisionSelection ? (IsViewable && isChecked) : isChecked"
                               v-bind:disabled="!IsViewable"
                               v-bind:class="IsSelectAbleArea('check') ? 'tree-treeText' : 'tree-treeText-disabled'"
                               @click="onCheckItem(divItem, $event, true)">
                    </label>
                </div>
            </template>
            <DivisionTreeItemText :divItem="divItem"
                                  :disableDivisionIds="disableDivisionIds"
                                  :isShowCheckIconEnableDivision="isShowCheckIconEnableDivision"
                                  :strDivisionIcon="mapDivisionIcon.get(divItem.divisionId)"
                                  :isInheritance="isInheritance"
                                  :selectMode="selectMode"
                                  :isViewable="IsViewable"
                                  @click="onCheckItem(divItem, $event, false)">
                <template v-for="(slot, name) in $slots" #[name]="data">
                    <slot :name="name" v-bind="data"></slot>
                </template>
            </DivisionTreeItemText>
        </div>
    </div>

    <template v-if="HasChildren">
        <ul class="nested" v-bind:class="{ active: isExpanded }">
            <li v-for="child in divItem.arChildren"
                v-bind:key="child.id">
                <DivisionTreeItem :divItem="child"
                                  :selectDivision="selectDivision"
                                  :disableDivisionIds="disableDivisionIds"
                                  :isShowCheckIconEnableDivision="isShowCheckIconEnableDivision"
                                  :viewableDivisionIds="viewableDivisionIds"
                                  :isInheritViewable="isInheritViewable"
                                  :initialCollapsedDivisionIds="initialCollapsedDivisionIds"
                                  :mapDivisionIcon="mapDivisionIcon"
                                  :isInheritance="isInheritance"
                                  :nHierarchy="nHierarchy + 1"
                                  @selectItem="selectItem"
                                  @expanded="onChildExpanded"
                                  @checkItem="checkItem"
                                  :isParentViewable="IsViewable"
                                  :selectMode="selectMode"
                                  :disableSelection="disableSelection"
                                  :treeSelectionLinkage="treeSelectionLinkage"
                                  :hideUnviewableDivisionSelection="hideUnviewableDivisionSelection"
                                  :expandOnUncheck="expandOnUncheck"
                                  @invalidSelect="onInvalidSelect">
                    <template v-for="(slot, name) in $slots" #[name]="data">
                        <slot :name="name" v-bind="data"></slot>
                    </template>
                </DivisionTreeItem>
            </li>
        </ul>
    </template>
</template>

<script lang="ts">
    import { Vue, Options } from "vue-class-component";
    import { DivisionData } from "@/models/DivisionData"
    import DivisionTreeItemText from "@/components/DivisionTree/DivisionTreeItemText.vue"
    import { TreeSelectionLinkage } from "@/components/DivisionTree/enums";

    @Options({
        props: {
            divItem: { type: DivisionData, required: true },            // [in] (必須)部署ツリー
            selectDivision: { type: DivisionData, required: true },     // [in] (必須)選択中の部署
            disableDivisionIds: { type: Set, default: new Set<number> },             // [in] (オプション)無効状態にする部署
            isShowCheckIconEnableDivision: { type: Boolean, default: false },// [in] (オプション) 有効な部署にチェックアイコンを表示する
            viewableDivisionIds: { type: Set, default: null },          // [in] (オプション)閲覧可能部署ID
            initialCollapsedDivisionIds: { Type: Set, default: new Set<number> },  // [in] (オプション)初期閉じた状態とする部署ID
            isInheritViewable: { type: Boolean, default: true },        // [in] (オプション)閲覧設定を子要素に引き継ぐか
            mapDivisionIcon: { type: Map, default: new Map() },         // [in]（オプション）部署IDとそのアイコン情報
            isInheritance: { type: Boolean, default: false },           // [in]（オプション）継承ツリーかどうか
            nHierarchy: { type: Number, default: 0 },                   // [in] 自階層
            selectMode: { type: Number, default: 0 },                   // [in]（オプション）選択方法 0 : 行選択（単一） 1 : チェックボックス（複数） 2 : チェックボックス（複数、親選択）
            isParentViewable: { type: Boolean, default: false },        // [in] 親に閲覧権限があるかどうか
            disableSelection: { type: Boolean, default: false },        // [in]（オプション）部署の選択を無効化するかどうか
            treeSelectionLinkage: { type: Number, default: TreeSelectionLinkage.Normal },
            // 閲覧不可部署のチェック状態を非表示にするかどうか
            hideUnviewableDivisionSelection: { type: Boolean, default: true },
            // チェックが外れたら配下を展開するかどうか
            expandOnUncheck: { type: Boolean, default: false },
        },
        emits: [
            // selectItem - 選択が押下されたときのコールバック(第一引数：クリックされた部署データ DivisionData(参照))
            // expanded   - 開閉されたときのコールバック
            // invalidSelect - 選択無効時のコールバック
            'selectItem',
            'expanded',
            'invalidSelect',

            /**
             * チェック通知 ※selectModeが1のときのみ通知される
             * 引数無し
             */
            'checkItem'
        ],
        components: {
            DivisionTreeItemText,
        },
        computed: {
            /*
             * 選択中の部署かどうか
             */
            IsHighlight: function () {
                // チェックモードの時は選択色の変更は不要
                if (0 == this.selectMode && this.divItem.divisionId == this.selectDivision.divisionId) {
                    if (!this.IsViewable) {
                        this.$emit('invalidSelect');
                    }

                    return true;
                }
                return false;
            }

            /*
             * ツリー構造を意識したパディングの値を返します
             */
            , HierarchyPadding: function () {
                var padding = this.nHierarchy * 28 /* 24px + 4px */;
                if (0 == this.divItem.arChildren.length) {
                    padding += 24;  // 子供がいないときの > のアイコンサイズ
                }
                return padding;
            }

            /*
             * 子要素を持つか
             */
            , HasChildren: function () {
                if (0 < this.divItem.arChildren.length) {
                    return true;
                }
                return false;
            }

            /*
             * 自身が閲覧可能かを判断します
             */
            , IsViewable: function () {
                return this.isViewable();
            }

            /*
             * 3ステート
             */
            , isIndeterminate: function () {
                return 2 === this.divItem.checkState;
            }

            /*
             * チェック状態
             */
            , isChecked: function () {
                return 1 === this.divItem.checkState;
            }

        },
        watch: {
            /*
             * 初期閉じた状態とする部署IDが変更された場合に反映
             */
            initialCollapsedDivisionIds: function () {
                this.isExpanded = !this.initialCollapsedDivisionIds.has(this.divItem.divisionId);
            },
        }
    })
    export default class DivisionTreeItem extends Vue {
        private readonly divItem!: DivisionData;                 // 部署情報
        private readonly selectDivision!: Readonly<DivisionData>;          // 選択中の部署情報
        private readonly disableDivisionIds!: Readonly<Set<number>>;       // 選択不可にする部署ID
        private readonly viewableDivisionIds!: Readonly<Set<number>>;      // 閲覧可能部署ID
        private readonly initialCollapsedDivisionIds!: Readonly<Set<number>>;  //初期閉じた状態とする部署ID
        private readonly isInheritViewable!: Readonly<boolean>;            // 閲覧設定を子要素に引き継ぐか
        private readonly mapDivisionIcon!: Readonly<Map<number, string>>;  // 部署IDとそのアイコン情報
        private isInheritance!: boolean;                                     // 継承ツリーかどうか
        private readonly nHierarchy!: number;                              // 自階層（階層ごとによってパディングの数値が変わる）
        private readonly selectMode!: number;                              // 選択方法 0 : 行選択（単一） 1 : チェックボックス（複数） 2 : チェックボックス（複数、親選択）
        private readonly SELECT_MODE_SINGLE = 0;    // 0 : 行選択（単一）
        private readonly SELECT_MODE_MULTIPLE = 1;  // 1 : チェックボックス（複数）
        private readonly disableSelection!: boolean;                       // 部署の選択を無効化するかどうか
        private treeSelectionLinkage!: TreeSelectionLinkage;
        private hideUnviewableDivisionSelection!: boolean;
        private expandOnUncheck!: boolean;

        private readonly isParentViewable!: boolean;    // 親の閲覧可能状態
        private isExpanded: boolean = true;             // 展開状態

        /**
        * mounted
        */
        public mounted(): void{
            // 初期展開状態を設定
            this.isExpanded = !this.initialCollapsedDivisionIds.has(this.divItem.divisionId);
        }

        /**
         * 矢印のクリック
         */
        public onClickExpand(): void {
            this.isExpanded = !this.isExpanded;
            this.$emit('expanded');
        }

        /**
         * 選択部署の変更
         * @param[in/out] selectDivision : 選択された部署情報
         */
        public onSelectItem(selectDivision: DivisionData, event: Event): void {
            if (this.disableSelection || (this.SELECT_MODE_SINGLE != this.selectMode)) {
                // 選択無効フラグONやチェックボックスのときは無視する
                return;
            }

            if (!this.isViewable()) {
                // 閲覧権限なしの部署がクリックされた
                return;
            }

            // 無効状態のテキストなら何もしない
            if (this.disableDivisionIds.has(selectDivision.divisionId)) {
                return;
            }

            // 行選択のときは、一番親が選択状態を持っているので
            // 選択状態を一番親まで教える必要がある
            this.$emit('selectItem', selectDivision);
        }
        
        /**
         * 選択可能エリア判定
         * @param[in/out] target : 対象範囲(row:行全体 check:チェックボックス text:テキスト)
         * #53482【M1】チェックボックス付き部署ツリーのカーソルアイコンに誤りがある
         */
        public IsSelectAbleArea(target: string): boolean {

            if ("row" == target && this.SELECT_MODE_SINGLE !== this.selectMode ) {
                // 対象が行全体 かつ 選択方法:行選択以外の場合はデフォルトカーソル
                return false;
            }

            if (this.disableDivisionIds.has(this.divItem.divisionId) || !this.isViewable()) {
                // 非活性の場合はデフォルトカーソル
                return false;
            }
            else {
                // 活性の場合は指カーソル
                return true;
            }
        }

        /**
         * チェック検知
         */
        private onCheckItem(selectDivision: DivisionData, event: Event, isCheckBox: boolean): void {
            if (this.SELECT_MODE_SINGLE == this.selectMode) {
                // 行選択のときはここは無視する
                return;
            }

            if (!this.isViewable()) {
                // 閲覧権限なしの部署がクリックされた
                event.preventDefault();
                return;
            }

            if (isCheckBox) {
                // clickイベント時ではselectDivisionのcheckStateがまだ更新されておらず、
                // コードでcheckStateを触ってもclick後の処理でselectDivision.checkStateが上書きされてしまう
                // そのため、checkコントロールからのイベントは中止して自前でonCheckItem()を実行する
                event.preventDefault();

                // 少し猶予を持たせてから実行しないとコードで編集したcheckStateが反映されない
                setTimeout(this.onCheckItem, 1, selectDivision, event, false);
                return;
            }

            // checkコントロール以外はここでチェック状態を変更する
            selectDivision.checkState = (selectDivision.checkState + 1) % 2;    // 3ステートには戻らない

            // 子部署のチェックについて
            // オンに変更：子部署もオンにする
            // オフに変更：shiftを押していたら子部署もオフにする
            //             shiftを押していなければ自部署だけオフにする
            if (0 < selectDivision.arChildren.length) {
                // 子部署のチェックも変更
                if (1 == selectDivision.checkState) {
                    // オンに変更されたときは子部署もオンにする
                    selectDivision.CheckChildDivision(true);
                }
                else {
                    if (TreeSelectionLinkage.SyncDescendants === this.treeSelectionLinkage) {
                        selectDivision.CheckChildDivision(false);
                    } else {
                        // オフに変更されたときは、shiftを押しながらクリックしたときのみ子部署もオフにする
                        if (undefined == event || !(event instanceof MouseEvent)) {
                            return;
                        }
                        if (event.shiftKey) {
                            selectDivision.CheckChildDivision(false);
                        }
                    }
                }
            }

            // 変更通知
            this.$emit('checkItem', selectDivision);
            if (this.expandOnUncheck && 0 === this.divItem.checkState) {
                this.isExpanded = true;
            }
        }

        /**
         * 子部署の選択通知
         */
        private selectItem(selectDivision: DivisionData): void {
            // 親に通知するだけ
            this.$emit('selectItem', selectDivision);
        }

        /**
         * 子部署のチェック通知
         */
        private checkItem(selectDivision: DivisionData): void {
            if (TreeSelectionLinkage.SyncAncestors === this.treeSelectionLinkage &&
                0 === selectDivision.checkState
            ) {
                // 子のチェックOFFを祖先に反映させる。
                const fp = (item: DivisionData) => {
                    if (item.divisionId === selectDivision.divisionId) return true;
                    if (item.arChildren.some(child => fp(child))) {
                        return true;
                    }
                    return false;
                }
                if (this.isViewable() && fp(this.divItem)) {
                    this.divItem.checkState = 0;
                }
            }

            // 親に通知
            this.$emit('checkItem', selectDivision);
        }

        /**
         * 子要素のリサイズ（子要素のonClickExpandが呼ばれた後にresizeのemitで呼ばれる）
         */
        private onChildExpanded(): void {
            this.$emit('expanded');
        }

        /**
         * 子要素の選択無効通知
         */
        private onInvalidSelect(): void {
            this.$emit('invalidSelect');
        }

        /*
         * 自身が閲覧可能かを判断します
         */
        private isViewable(): boolean {
            if (this.isInheritViewable && this.isParentViewable) {
                // 子要素に継承する設定の時は、親が閲覧可能なら許可
                return true;
            }

            // 閲覧可能部署の指定がない場合はすべて許可とする
            if (!this.viewableDivisionIds) {
                return true;
            }

            if (this.viewableDivisionIds.has(this.divItem.divisionId)) {
                return true;
            }

            return false;
        }
    }
</script>

<style scoped>
    ul {
        list-style-type: none;
    }

    li {
        text-align: center;
    }

    .nested {
        display: none;
        padding: 0px;
    }

    .active {
        display: block;
    }

    .cursor-default {
        cursor: default;
    }

</style>
